export default __webpack_public_path__ + "static/media/edital42024final.02e88697.pdf";